<template>
  <!-- 此界面作为路由分发界面 -->
  <div>
    <login-page ref="loginBox" :is-from-p6="isFromP6" :user-info="account" :account-err-msg="accountErrorMsg" @login="login" />
    <div style="display: none;" v-if="false">
      <!--<iframe src="https://ebq.gfgwxw.top/mainv2/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0px;height: 0px;"></iframe>-->
      <!--<iframe src="https://ebq.gfgwxw.top/calculate/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <!--<iframe src="https://ebq.gfgwxw.top/archive/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <!--<iframe src="https://ebq.gfgwxw.top/buildingside/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <!--<iframe src="https://ebq.gfgwxw.top/constructionside/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <!--<iframe src="https://ebq.gfgwxw.top/datascreen/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <!--<iframe src="https://ebq.gfgwxw.top/valuationbasis/#/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <iframe v-for="frame in frameList" :key="frame" :src="`${dcostUrl}/${frame}?timestamp=${key}`"  frameborder="0"></iframe>
      <iframe v-for="sub in subList" :key="sub" :src="`${subUrl}/${sub}/#/`" frameborder="0" />
      <!--<iframe src="https://qydata-qylib-test.glodon.com/" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
      <!--<iframe src="https://zcost-test.glodon.com" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>-->
    </div>
  </div>
</template>
<script>
import LoginPage from '@/views/component/LoginPage'
import { subUrl, geipUrl, dcostUrl } from '@/config'

export default {
  name: 'FormalLogin',
  components: { LoginPage },
  data () {
    return {
      key: Date.now(),
      subUrl: subUrl,
      geipUrl,
      dcostUrl,
      frameList: ['cost-web', 'cost-web-grant'],
      subList: ['mainv2', 'calculate', 'archive', 'buildingside', 'front-share', 'constructionside', 'indexDataScreen', 'datascreen', 'valuationbasis', 'est', 'enterprisenorm', 'zbtemplate-front', 'mbcb-front', 'ie-front', 'gs-front'],
      currentUrl: null, // 当前浏览器url
      accountErrorMsg: null,
      account: null,
      target: '/portal/?applicationCode=dcost&productCode=dcost&viewMode=full',
      compatibleUrl: null, // 兼容后的url
      urlType: null, // 前端定义当前旧端类型
      isFromP6: null // 是否从p6跳转
      // targetParam: null
    }
  },
  async mounted () {
    // if (!geipToken) {
    //   this.clearCache()
    //   return
    // }
    // const isAlive = await this.checkSession()
    // if(isAlive){
    //   this.$router.push({
    //     path: `/iframePortal/${window.location.hash}`,
    //   })
    // }
    // const windowUrl = localStorage.getItem('windowUrl')
    // if (windowUrl && windowUrl.includes('#/mainv2')) {
    //   history.replaceState(null, null, windowUrl)
    // }
    setTimeout(() => {
      if (
        this.currentUrl.includes('#/login') ||
        this.currentUrl.includes('#/mainv2')
      ) {
        this.initCompatibleUrl()
      }
    }, 500)
  },
  // mounted () {
  //   ['mainv2', 'calculate', 'archive', 'buildingside', 'constructionside', 'datascreen', 'valuationbasis'].forEach(async url => {
  //     const { getExternalScripts } = await importEntry(`https://ebq-test.gfgwxw.top/${url}/#/`)
  //     await getExternalScripts()
  //   })
  // },
  methods: {
    async login (geipToken, gldToken, gldUserId, tenantId, authEnterpriseId, roleId) {
      console.log(geipToken, gldToken, gldUserId, tenantId)
      if (this.$refs.loginBox.activeName === 'password') {
        this.sentLog('100101004', { result: '成功', type: this.$refs.loginBox.userType }, geipToken, gldUserId)
      } else {
        this.sentLog('100101005', { result: '成功', type: this.$refs.loginBox.userType }, geipToken, gldUserId)
      }
      // 活动分享链接登录成功后回调
      if (this.$route.query.gldUserId) {
        try {
          await this.$api.home.addTimes({ gldUserId: this.$route.query.gldUserId }, { authorization: geipToken })
        } catch (e) {
          console.log(e.message)
        }
      }
      let isPasswordChange = false
      if (this.urlType === 2) {
        // 判断密码是否更改
        if (this.$refs.loginBox.formAccount.password === this.account) {
          isPasswordChange = true
        }
      }
      // const condition = querystring.encode({
      //   ...this.targetParam,
      //     isPasswordChange,
      //     local_token: geipToken
      // })
      this.getAccountURL(geipToken, gldToken, gldUserId, tenantId, isPasswordChange, authEnterpriseId, roleId)
    },
    // 组装参数
    initCompatibleUrl () {
      if (this.currentParams) {
        // 第二种
        let param = ''
        if (this.params.hasPermission === 'true') {
          param = encodeURIComponent(`/usableAccount=${this.params.usableAccount}&isFromGCCP=${this.params.isFromGCCP}&productId=${this.params.productId}&projectPath=${encodeURIComponent(this.params.projectPath)}&projectName=${this.params.projectName}&mac=${this.params.mac}`)

          if (this.params.usableAccount) {
            setTimeout(() => {
              this.account = this.params.usableAccount
            }, 1000)

            this.urlType = 2
            this.targetParam = {
              menuCode: this.params.tabName,
              path: param
            }
          } else {
            this.accountErrorMsg = '抱歉，您还没有购买广联达施工方成本测算产品，请联系当地销售员购买！'
            this.targetParam = {
              menuCode: 'dcost.module.qdbj',
              path: param
            }
          }
        } else if (this.params.hasPermission === 'false') {
          param = encodeURIComponent(`/usableAccount=${this.params.usableAccount}&isFromGCCP=${this.params.isFromGCCP}&productId=${this.params.productId}&projectPath=${encodeURIComponent(this.params.projectPath)}&projectName=${this.params.projectName}&mac=${this.params.mac}`)
          if (this.params.tabName === 'dcost.module.sgcbcs') {
            this.accountErrorMsg = '抱歉，您还没有购买广联达市场化计价成本测算，请联系当地销售员购买！'
          } else {
            this.accountErrorMsg = '抱歉，您还没有购买广联达市场化计价，请联系当地销售员购买！'
          }
          this.targetParam = {
            menuCode: 'dcost.module.qdbj',
            path: param
          }
        }
        // // 第三种
        // if (this.currentUrl.includes('#/login/sso')) {
        //   this.compatibleUrl = `${this.target}&menuCode=calculate`
        // }
        // 第四种
        if (this.params.isFromP6) {
          setTimeout(() => {
            this.account = this.params.account
          }, 1000)
          this.targetParam = {
            menuCode: this.params.tabName,
            path: param
          }
          this.isFromP6 = true
        }
      } else {
        if (this.currentUrl.includes('#/mainv2')) {
          // 第五种
          this.targetParam = {
            menuCode: 'dcost.module.qdbj',
            path: this.currentUrl.split('#/mainv2')[1]
          }
        } else { // url为https://ebq.glodon.com/#/login
          // 第一种
          this.targetParam = {
            menuCode: 'dcost.module.qdbz'
          }
        }
      }
    }
    // 获取jobList--用于埋点
  }
}
</script>
